export default {"src":"/_next/static/media/TextOutdent.06499f61.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};